import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { iif, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { CookieKey } from '../../models/cookie-key.model';
import { UserContextService } from '../../services/user-context-service/user-context.service';

export const routeGuard: CanActivateFn = () => {
  const router: Router = inject(Router);
  const userContextService: UserContextService = inject(UserContextService);
  const cookieService: CookieService = inject(CookieService);

  return userContextService
    .getAuthenticatedUser()
    .pipe(
      switchMap(userContext =>
        iif(() => userContext !== null && cookieService.check(CookieKey.IsLoggedIn), of(true), of(router.parseUrl('/authenticate')))
      )
    );
};
